
















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Watch, Mixins, Ref} from 'vue-property-decorator';
import tradeBank from '@/const/words/tradeBank';
import { pattern } from '@/const/regex';
import LayerPopup from '@/components/LayerPopup.vue';
import { toI18n } from '@/utils/commonUtils';
import {
  PatchNotificationsConfigurationsRequest,
  PostMembersOpenidconfigRequest,
  PutOrderconfigsCartRequest,
  PutOrderconfigsOrderRequest,
  GetMallsDataRequest,
  GetOrderconfigsCartRequest,
  GetSettlementsconfigurationsRequest,
  PutMallsRequest,
  PutAccumulationsConfigurationsRequest,
  PutOrderConfigsShippingRequest,
  GetContractsEntryConfigurationsRequest,
  PutContractsEntryConfigurationsRequest,
  PutContractfilesMallsRequest,
  PatchProductsConfigurationRequest,
  PutProductsConfigurationRequest,
  PutOrderConfigsPaymentsPayTypesRequest,
  EnablePays,
  ConfigurationI18n,
  EnumsType,
  MembersCommonJoinConfig,
  Mall,
  PatchSettlementsConfigurationsRequest,
  PGPayTypes,
  NCPResponse,
  GetOrderConfigsOrder,
  GetOrderConfigsPaymentsPgRequest,
  ClaimsConfigs,
} from 'supporter';
import { ncpPopup } from '@/utils/ncp';
import InstagramIntegrationForm from '@/components/mall/InstagramIntegrationForm.vue';
import KakaosyncSettingForm from '@/components/mall/KakaosyncSettingForm.vue';
import _ from 'underscore';

interface ContractFile {
  title?: string;
  originalFileName?: string;
  uploadedFileName?: string;
  isDownloadShow?: boolean;
  isXShow?: boolean;
  isError?: boolean;
  domestic?: boolean;
  originalName?: string;
  displayOrder?: number;
  uploadedName?: string;
}

type DeepLinkType = 'aos' | 'ios';

import LengthCounter from '@/components/common/input/LengthCounter.vue';
import ValidateInput from '@/components/common/input/ValidateInput.vue';
import PopUpAdNoticeMixin from '@/views/member/mixins/PopUpAdNoticeMixin.vue';
import OauthTypeNotice from '@/views/member/popup/OauthTypeNotice.vue';
import RadioGroup from '@/pro/components/common/RadioGroup.vue';
import NumberInput from '@/components/common/NumberInput.vue';

import { v4 } from 'uuid';
import { GET_SHIPPING_CONFIG_PRESENTATIONAL_DATA, DEFAULT_SHIPPING_CONFIG } from '@/views/mall/mallFormInit';

import { RadioBoxGroupOption } from '@/pro/helpers/type';
import { namespace, State } from 'vuex-class';
import axios from 'axios';
import {SHOPBY_ACCESSTOKEN} from '@/const/words/cookie';
import {getCookie} from '@/utils/cookieUtils';
import PaymentSetting from './PaymentSetting.vue';

import { CurrencyCode } from 'supporter';
import type { Admin } from '@/types';

const adminModule = namespace('admin');

const AOS_FILE_NAME = 'assetlinks.json';
const IOS_FILE_NAME = 'apple-app-site-association.json';
const accessToken = getCookie(SHOPBY_ACCESSTOKEN);

@Component({
  components: {ValidateInput, LengthCounter, InstagramIntegrationForm, LayerPopup, OauthTypeNotice, RadioGroup, KakaosyncSettingForm, PaymentSetting, NumberInput }
})
export default class MallForm extends Mixins(PopUpAdNoticeMixin) {
  @adminModule.Getter('admin') private admin!: Admin;

  get settlementConfigNotes() {
    return this.$t('MALL_FORM_ORDERCONFIG_SETTLEMENT_CONFIG_NOTES', {
      returnObjects: true,
    });
  }

  @State('malls', { namespace: 'mall' })
  private malls!: Mall[];

  private makeUniqueId = v4;

  private mallNo: string = this.$route.params.id;

  private get isExistMall() {
    const mallCreatedDateTime = this.malls.find(({ mallNo }) => mallNo === Number(this.mallNo))?.createdDateTime ?? '';
    const saasOpenTime = new Date('2023-05-02 00:00:00').getTime();
    return saasOpenTime - new Date(mallCreatedDateTime).getTime() <= 0;
  }

  // mall
  private mall: any = {
    mallName: '',
    globalMallType: 'LOCAL',
    // countryCode: 'NONE',
    timeZone: 'NONE',
    used: true,
    url: {
      pc: '',
      android: '',
      mobile: '',
      ios: '',
    },
    serviceCenterPhoneNo: '',
    emailId: '',
    emailDomain: '',
    outboundEmailId: 'noreply',
    outboundEmailDomain: '',
    serviceCenter: {
      outboundEmail: '',
      phoneNo: '',
      email: '',
    },
  };
  private commonJoinConfig: MembersCommonJoinConfig = null;
  private isMaximumOrderAmountPopup = false;
  private countries: EnumsType[] = [];
  private defaultOrderAmountsForm: { key: string, name: string, value: string | number } = { key: this.makeUniqueId(), name: '', value: '' };
  private maximumOrderAmounts = [{ ...this.defaultOrderAmountsForm }];
  private isMallNameErrorShow: boolean = false;
  private clientId: string = '';
  private externalApiKey: string = '';
  private emailCopy: any = '';
  private isOutEmailDisabled: boolean = false;
  private isPhoneErrShow: boolean = false;
  private isEmailErrShow: boolean = false;
  private isOutEmailErrShow: boolean = false;
  // deep link
  private aosFIleUrl = '';
  private iosFIleUrl = '';
  private aosFileName = '';
  private iosFileName = '';
  private aosUploadedFileName: null | string = null;
  private iosUploadedFileName: null | string = null;

  // 글로벌몰의 경우,
  private hihihi;
  //  contract file
  private koreaConFileList: ContractFile[] = [
    {
      title: '',
      originalFileName: '',
      uploadedFileName: '',
      isDownloadShow: true,
      isXShow: false,
      isError: false,
    },
  ];
  private foreignConFileList: ContractFile[] = [
    {
      title: '',
      originalFileName: '',
      uploadedFileName: '',
      isDownloadShow: true,
      isXShow: false,
      isError: false,
    },
  ];
  private readonly MAX_FILE_COUNT = 7;
  private isPlusDisabled: boolean = false;
  private isPlus2Disabled: boolean = false;
  private koreaFileGuide: string = '';
  private foreignFileGuide: string = '';
  // tradeBankAccountInfo
  private bankList: any[] = tradeBank;
  private tradeBankAccountInfo: any[] = [
    {
      bank: '',
      bankAccount: '',
      bankDepositorName: '',
      isErrorShow: false,
      isDisabled: false,
    },
    {
      bank: '',
      bankAccount: '',
      bankDepositorName: '',
      isErrorShow: false,
      isDisabled: false,
    },
    {
      bank: '',
      bankAccount: '',
      bankDepositorName: '',
      isErrorShow: false,
      isDisabled: false,
    },
    {
      bank: '',
      bankAccount: '',
      bankDepositorName: '',
      isErrorShow: false,
      isDisabled: false,
    },
    {
      bank: '',
      bankAccount: '',
      bankDepositorName: '',
      isErrorShow: false,
      isDisabled: false,
    },
  ];
  // notification
  private notification: any = {
    smsUsed: true,
    emailUsed: true,
    publicEmailAppkey: '',
    publicSmsAppkey: '',
    smsSendNo: '',
  };
  private sendPopUpRequestData: any = {
    id: 'requestSendNo',
    hasConfirmBtn: false,
    hasCloseBtn: false,
    title: 'MALL_FORM_REQUESTSENDNO_TIT',
    width: 700,
    maxHeight: 700,
  };
  private isSmsError: boolean = false;
  private isEmailError: boolean = false;
  private isEmailAppkeyDisabled: boolean = false;
  private isEmailBtnShow: boolean = false;

  // mallJoinConfig
  private mallJoinConfig: any = {
    used: true,
    memberAuthenticationType: 'AUTHENTICATION_BY_PHONE',
    authenticationTimeType: 'JOIN_TIME',
    authenticationUsed: true,
    dormantStatusUsed: true,
  };
  private isAnotherDisabled1: boolean = false;
  private isAuthUsedDisabled: boolean = false;
  // openIdJoinConfig
  private openIdJoinConfig: any = {
    authenticationUsed: true,
    memberAuthenticationType: 'AUTHENTICATION_BY_PHONE',
    authenticationTimeType: 'JOIN_TIME',
    redirectUrlForPc: '',
    redirectUrlForMobile: '',
    redirectUrlForAos: '',
    redirectUrlForIos: '',
    clientId: {},
    secretKey: {},
    privacyCollectionUsed: false,
    privacyCollectionSource: '',
  };
  private isAnotherDisabled2: boolean = false;
  // joinConfig
  private joinConfig: any = {
    payco: {
      checked: false,
      clientId: '',
      secretKey: '',
      readonly: false,
    },
    naver: { checked: false, clientId: '', secretKey: '', readonly: false },
    kakao: { checked: false, clientId: '', secretKey: '', readonly: false },
    facebook: { checked: false, clientId: '', secretKey: '', readonly: false },
    line: { checked: false, clientId: '', secretKey: '', readonly: false },
  };
  private isPaycoDisabled: boolean = true;
  private isNaverDisabled: boolean = true;
  private isKakaoDisabled: boolean = true;
  private isFbDisabled: boolean = true;
  private isLineDisabled: boolean = true;
  // cartConfig
  private storagePeriodList: any[] = [1, 2, 3, 4, 5, 6, 7, 15, 30];
  private storageMaxQuantityList: any[] = [10, 20, 30, 40, 50, 100];
  private cartConfig: any = {
    storagePeriodNoLimit: true,
    storagePeriod: 7,
    storageMaxQuantity: 50,
    cartEquivalentOptionUnitType: 'ROW',
  };
  private isCartConfigUnitTypeDisabled: boolean = false;
  private isStoragePeriodDisabled: boolean = true;
  private isContractFileGuidePopShow: boolean = false;
  private isJoinApproveConfigPopupShow: boolean = false;
  private MaximumOrderAmountPopupRequestData = {
    id: 'maximumOrderAmountPopup',
    hasConfirmBtn: false,
    title: this.$t('MALL_FORM_MAXIMUM_ORDER_AMOUNT'),
    width: 570,
  };
  private ContractFileGuidePopupRequestData = {
    id: 'contractFileGuidePopup',
    hasConfirmBtn: false,
    title: 'MALL_FORM_CONTRACT_FILES_TITLE',
    width: 570,
  };
  private JoinApproveConfigPopupRequestData = {
    id: 'isJoinApproveConfigPopup',
    hasConfirmBtn: false,
    title: this.$t('MALL_FORM_JOIN_APPROVE_CONFIG'),
    width: 570,
  };
  private isCartPopShow: boolean = false;
  private cartpPopupRequestData: any = {
    id: 'cartPopUp',
    hasConfirmBtn: false,
    title: 'MALL_FORM_CARTPOPUP_TIT',
    width: 570,
  };
  // accumulationConfig
  private accumulationConfig: any = {
    productAccumulationUsable: true,
    memberAccumulationUsable: true,
  };
  private isAccumulationPopShow: boolean = false;
  private accumulationPopupRequestData: any = {
    id: 'accumulationPopUp',
    hasConfirmBtn: false,
    title: 'MALL_FORM_ACCUMULATIONPOPUP_TIT',
    width: 570,
  };
  private isOpenAosMobilePopover = false;
  private isOpenIosMobilePopover = false;
  private aosMobilePopoverData = {
    id: 'aosMobilePopover',
    hasConfirmBtn: false,
    title: 'MALL_FORM_AOS_MOBILE_DEEP_LINK',
    width: 570,
  };
  private iosMobilePopoverData = {
    id: 'iosMobilePopover',
    hasConfirmBtn: false,
    title: 'MALL_FORM_IOS_MOBILE_DEEP_LINK',
    width: 570,
  };
  private naverpayConfig = {
    paymentEnabled: false,
    paymentExposure: false,
    orderEnabled: false,
    orderExposure: false,
  };
  // productConfig
  private productConfig: any = {
    categoryCommissionUsed: true,
    productDetailUrl: '',
    productDetailUrlForMobile: '',
    wmsUsed: false,
    wmsCompany: 'CJINEX',
    // NUMBER
    safetyStockControlPoint: '',
    // NUMBER
    safetyStockRatio: '',
    // NUMBER
    safetyStockCount: '',
    displayStock: true,
  };
  private isProductWmsDisabled: boolean = false;
  private isWmsTypeDisabled: boolean = true;
  private isProductPopShow: boolean = false;
  private isWmsErrShow: boolean = false;
  private isWmsFailShow: boolean = false;
  private isWmsAlertShow: boolean = false;
  private productPopupRequestData: any = {
    id: 'productPopUp',
    hasConfirmBtn: false,
    title: 'MALL_FORM_PRODUCTPOPUP_TIT',
    width: 700,
  };
  // orderConfig  FINISH
  private orderConfig: any = {
    domesticLimitDeliveryIngDays: 3,
    overseasLimitDeliveryIngDays: 10,
    limitDeliveryDoneDays: 7,
    accountLimitPayWaitDays: 7,
  };
  private claimConfig: ClaimsConfigs['value'] = {
    allowsCustomerCancelOrder: true,
  };
  // settlementsConfig  FINISH
  private settlementsConfig: PatchSettlementsConfigurationsRequest['data'] = {
    settlementTargetStatus: 'BUY_CONFIRM',
  };
  private settlementPeriodTypeList: any[] = [
    {
      value: 'MONTH',
      name: this.$t('MALL_FORM_ORDERCONFIG_SETTLEMENTPERIODTYPE1'),
    },
    {
      value: 'WEEK',
      name: this.$t('MALL_FORM_ORDERCONFIG_SETTLEMENTPERIODTYPE2'),
    },
    {
      value: 'DAY',
      name: this.$t('MALL_FORM_ORDERCONFIG_SETTLEMENTPERIODTYPE3'),
    },
  ];
  private settlementTargetStatusList: any[] = [
    {
      value: 'DELIVERY_ING',
      name: this.$t('MALL_FORM_ORDERCONFIG_SETTLEMENTTARGETSTATUS1'),
    },
    {
      value: 'DELIVERY_DONE',
      name: this.$t('MALL_FORM_ORDERCONFIG_SETTLEMENTTARGETSTATUS2'),
    },
    {
      value: 'BUY_CONFIRM',
      name: this.$t('MALL_FORM_ORDERCONFIG_SETTLEMENTTARGETSTATUS3'),
    },
  ];
  private domesticLimitDeliveryIngDaysList: any[] = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
  ];
  private accountLimitPayWaitDaysList: number[] = Array.from({ length: 30 }).map((_, i) => i + 1);
  private limitPayWaitDaysList = Array.from({ length: 31 }).map((_, i) => ({
    label: i === 0 ? '당일' : `${i}일`,
    value: i,
  }));

  // 배송 설정
  private readonly presentationalShippingConfig = { ...GET_SHIPPING_CONFIG_PRESENTATIONAL_DATA() };
  private shippingConfig = { ...DEFAULT_SHIPPING_CONFIG };
  private showShippingEmptyAutoCancelPopup = false;
  private showShippingInputNotificationPopup = false;

  private isShippingPopShow: boolean = false;
  private isRecurringPaymentPopShow: boolean = false;
  private recurringPaymentPopupRequestData: any = {
    id: 'recurringPaymentPopUp',
    hasConfirmBtn: false,
    title: '정기결제(배송) 배송지 입력 URL 안내',
    width: 650,
  };

  private shippingPopupRequestData: any = {
    id: 'shippingPopUp',
    hasConfirmBtn: false,
    title: 'MALL_FORM_SHIPPINGPOPUP_TIT',
    width: 630,
  };

  //stock display
  private isStockDisplayPopShow: boolean = false;
  private stockDisplayPopupRequestData: any = {
    id: 'stockDisplayPopUp',
    hasConfirmBtn: false,
    title: 'MALL_FORM_STOCKDISPLAYPOPUP_TIT',
    width: 570,
  };

  // productConfig.
  private stockRadioOptions: RadioBoxGroupOption<boolean> = {
    name: 'stockOption',
    data: [
      {
        // 재고 노출함
        id: 'STOCK_OPEN',
        value: true,
        display: this.$t('MALL_FORM_EXPOSED'),
      },
      {
        // 재고 노출 안 함
        id: 'STOCK_CLOSE',
        value: false,
        display: this.$t('MALL_FORM_DO_NOT_EXPOSE'),
      },
    ],
  };

  private joinApproveSetting: RadioBoxGroupOption<boolean> = {
    name: 'join-approve',
    data: [
      {
        id: 'approve-not-used',
        value: false,
        display: 'MALL_FORM_APPROVE_NOT_USED',
      },
      {
        id: 'approve-used',
        value: true,
        display: 'MALL_FORM_APPROVE_USED',
      },
    ],
  };

  private currencySetting: RadioBoxGroupOption<string> = {
    name: 'currency-option',
    data: [
      {
        id: 'KRW',
        value: 'KRW',
        display: 'KRW(₩)',
      },
      {
        id: 'USD',
        value: 'USD',
        display: 'USD($)',
      },
      {
        id: 'JPY',
        value: 'JPY',
        display: 'JPY(¥)',
      },
    ],
  };

  private selectedCurrency = 'KRW';
  private isInitialSubMallSetup = false;

  private onChangeJoinApprove(value: boolean) {
    // if (!this.isEditPage) return;

    // this.$nextTick(() => this.$set(this.mallJoinConfig, 'pendingStatusUsed', value));
    this.mallJoinConfig.pendingStatusUsed = value;
  }

  // 정기배송 설정 임시 숨김처리
  // // recurring-payment config
  // private recurringPaymentConfig: PutOrderconfigsOrderRequest['data']['recurringPaymentConfig'] = {
  //   pgType: 'KCP',
  //   siteKey: '',
  //   siteCode: '',
  //   groupId: '',
  // }
  // private isRecurringPaymentUsed = false;
  /* =======================modification area============= */
  private isMobileAppPopShow: boolean = false;
  private mobileAppGuidancePopupRequestData: any = {
    id: 'mobileAppGuidancePopUp',
    hasConfirmBtn: false,
    title: 'MALL_FORM_MOBILEAPPGUIDANCEPOPUP_TIT',
    width: 600,
  };
  private isHaveContract: boolean = false;
  private contractContent: string = '';
  private sendNoList: any[] = [];
  private isSendNoError: boolean = false;
  private newSendNo: any = {
    phoneNo: '',
    originalFileName: '',
    uploadedFileName: '',
  };
  private currencyExchange = {
    KRW: { value: '1', specialChar: '￦' },
    USD: { value: '', specialChar: '$' },
    JPY: { value: '', specialChar: '￥' },
    CNY: { value: '', specialChar: '元' },
  };
  private configurationI18n: ConfigurationI18n = {
    languages: ['KO'],
    currencies: [
      {
        exchangeTo: 'KRW',
        exchangeRate: 1,
      },
    ],
  };
  private paymentsPayTypes:EnablePays[] = [];
  private pgPayTypes: PGPayTypes[] = [];

  @Ref() private readonly paymentSettingRef: PaymentSetting;

  @Watch('mallJoinConfig.used')
  private configUsedWatch(val) {
    if (val) {
      this.isAuthUsedDisabled = false;
      if (this.mallJoinConfig.authenticationUsed) {
        this.isAnotherDisabled1 = false;
      } else {
        this.isAnotherDisabled1 = true;
      }
    } else {
      this.isAuthUsedDisabled = true;
    }
  }
  @Watch('mallJoinConfig.authenticationUsed')
  private mallConfigUsedWatch() {
    if (this.mallJoinConfig.authenticationUsed == false) {
      this.isAnotherDisabled1 = true;
    } else {
      this.isAnotherDisabled1 = false;
      this.mallJoinConfig.memberAuthenticationType = this.usableMemberAuthenticationType()[0];
    }
  }
  @Watch('openIdJoinConfig.authenticationUsed')
  private openConfigUsedWatch() {
    if (this.openIdJoinConfig.authenticationUsed == false) {
      this.isAnotherDisabled2 = true;
    } else {
      this.isAnotherDisabled2 = false;
    }
  }
  @Watch('cartConfig.storagePeriodNoLimit')
  private storagePeriodNoLimitWatch() {
    if (this.cartConfig.storagePeriodNoLimit) {
      this.isStoragePeriodDisabled = true;
    } else {
      this.isStoragePeriodDisabled = false;
    }
  }
  @Watch('productConfig.wmsUsed')
  private wmsUsedWatch() {
    if (this.productConfig.wmsUsed) {
      this.isWmsTypeDisabled = false;
    } else {
      this.isWmsTypeDisabled = true;
    }
  }
  private emailCopyMethod(copyDirect: boolean): void {
    if (this.emailCopy) {
      this.isOutEmailDisabled = true;
      this.mall.outboundEmailId = this.mall.emailId;
      this.mall.outboundEmailDomain = this.mall.emailDomain;
    } else {
      if (copyDirect) {
        this.mall.outboundEmailId = '';
        this.mall.outboundEmailDomain = '';
        this.isOutEmailDisabled = false;
      }
    }
  }
  @Watch('emailCopy')
  private emailCopyWatchTriggerByEmailCopy() {
    this.emailCopyMethod(true);
  }
  @Watch('mall.emailId')
  @Watch('mall.emailDomain')
  private emailCopyWatchTriggerByEmailId() {
    this.emailCopyMethod(false);
  }
  private onChangeExchange(e: KeyboardEvent, type: string) {
    if (!this.currencyExchange[type]) {
      return;
    }

    const parseValue = this.checkAmount(e, { beforeDot: 9, afterDot: 2, prevData: this.currencyExchange[type].value });
    this.currencyExchange[type].value = parseValue;
  }
  private onBlurExchange(e: KeyboardEvent, type: string) {
    if (!this.currencyExchange[type]) {
      return;
    }

    const target = e.target as HTMLInputElement;

    if (target.value === '0') {
      this.currencyExchange[type].value = '';
    }
  }
  private onChangeMaximumOrderAmount(e: KeyboardEvent, index: number) {
    const parseValue = this.checkAmount(e, {
      beforeDot: 9,
      afterDot: 0,
      prevData: this.maximumOrderAmounts[index].value,
    });
    this.maximumOrderAmounts[index].value = parseValue;
  }
  private checkAmount(e: KeyboardEvent, { beforeDot = 1, afterDot = 0, prevData }) {
    const target = e.target as HTMLInputElement;
    const regex = new RegExp(`^[0-9]{1,${beforeDot}}([.][0-9]{1,2})?$`);
    const isValid = regex.test(target.value);
    const checkBackspace = e.key === 'Backspace' || e.key === 'Delete';
    const checkDecimalPoint =
      e.key === '.' &&
      target.value.indexOf('.') > target.value.length - afterDot &&
      target.value.split('.').length < afterDot + 1;

    if (!isValid && !checkBackspace && !checkDecimalPoint) {
      e.preventDefault();
      target.value = prevData;
    }

    return target.value;
  }
  private selectedCountry(country: string) {
    return this.maximumOrderAmounts.some(item => item.name === country);
  }
  private addOrderAmount() {
    this.maximumOrderAmounts.push({ ...this.defaultOrderAmountsForm, key: this.makeUniqueId(), name: '', value: '' });
  }
  private removeOrderAmount(key: string) {
    this.maximumOrderAmounts = this.maximumOrderAmounts.filter(item => item.key !== key);
  }
  private calculateExchange(index: number, currency: 'USD' | 'JPY' | 'CNY') {
    const maximumOrderAmount = Number(this.maximumOrderAmounts[index].value);
    const exchange = Number(this.currencyExchange[currency].value);
    const calculatedExchange =
      maximumOrderAmount && exchange ? Math.floor((maximumOrderAmount / exchange) * 100) / 100 : 0;

    return calculatedExchange;
  }
  private validatePurchaseLimitByCountry() {
    for (const key in this.maximumOrderAmounts) {
      if (this.maximumOrderAmounts[key].name && !Number(this.maximumOrderAmounts[key].value ?? 0)) {
        alert(this.$t('MALL_FORM_NO_MAX_AMOUNT_ALERT'));
        return false;
      }

      if (!this.maximumOrderAmounts[key].name && Number(this.maximumOrderAmounts[key].value ?? 0)) {
        alert(this.$t('MALL_FORM_NO_COUNTRY_ALERT'));
        return false;
      }
    }

    return true;
  }

  private productAccumulationUsableChange(e) {
    const val: any = $(e.target).val();
    if (val === 'false' && !confirm(this.$t('MALL_FORM_CONFIRM_PRODUCT_ACCUMULATION_CHANGE') as string)) {
      $('input:radio[name="accumulationConfig.productAccumulationUsable"][value="true"]').click();
    }
  }
  private memberAccumulationUsableChange(e) {
    const val: any = $(e.target).val();
    if (val === 'false' && !confirm(this.$t('MALL_FORM_CONFIRM_MEMBER_ACCUMULATION_CHANGE') as string)) {
      $('input:radio[name="accumulationConfig.memberAccumulationUsable"][value="true"]').click();
    }
  }

  private async getMembersCommonJoinConfig(mallNo: number) {
    this.commonJoinConfig = (await this.$api.getMembersCommonJoinConfig({ params: { mallNo } })).data;
  }

  private usableMemberAuthenticationType() {
    const usableType = [];

    if (this.commonJoinConfig?.used) {
      // SMS 인증
      [
        this.commonJoinConfig.memberName,
        this.commonJoinConfig.birthday,
        this.commonJoinConfig.sex,
        this.commonJoinConfig.mobileNo,
      ].every(item => item !== 'NOT_USED') && usableType.push('AUTHENTICATION_BY_PHONE');

      // 휴대폰 인증
      this.commonJoinConfig.mobileNo !== 'NOT_USED' && usableType.push('SMS_OCCUPANCY_AUTHENTICATION');
    } else {
      usableType.push('AUTHENTICATION_BY_PHONE');
      usableType.push('SMS_OCCUPANCY_AUTHENTICATION');
    }

    // 이메일 인증
    usableType.push('AUTHENTICATION_BY_EMAIL');

    return usableType;
  }

  //결제수단 노출설정 get
  private async fetchPayTypes() {
    const request: GetOrderConfigsPaymentsPgRequest = { params: { mallNo: this.mallNo } };
    try {
      const { data }: NCPResponse<PGPayTypes[]> = await this.$api.getOrderConfigsPaymentsPayTypes(request);

      // this.pgPayTypes = data; // 이렇게 하면 주소값이 달라져서 sync 에서 감지하지 못함
      // this.$set(this, 'pgPayTypes', data); // 이렇게 해도 sync 에서 감지하지 못함
      this.pgPayTypes.splice(0, this.pgPayTypes.length); // 원본을 유지하면서 데이터만 변경해줌
      this.pgPayTypes.push(...data);
    } catch (e) {
      console.error(e);
    }
  }

  created() {
    if (this.mallNo) {
      this.getFormData();
      this.getContract();
      this.getMembersCommonJoinConfig(Number(this.mallNo));
      this.fetchDeepLinkInfo();
      this.fetchPayTypes();
    }
  }

  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t(needToI18nStr));
  }
  private sentenceLineAlignment(text: string): string[] {
    return text.split('\n');
  }
  private urlOpen(url) {
    let newUrl = '';
    newUrl = !this.mall.url[url].startsWith('http') ? `http://${this.mall.url[url]}` : this.mall.url[url];
    window.open(newUrl);
  }
  private uploadFile(index, kOrF) {
    if (kOrF === 'k') {
      $(`input[name=addFileInput_Y_${index}]`).click();
    }
    if (kOrF === 'f') {
      $(`input[name=addFileInput_N_${index}]`).click();
    }
  }

  private checkFileTitle(e: Event, item, kOrF: 'K' | 'F', index: number) {
    const value = (e.target as HTMLInputElement).value;
    const validate = new RegExp(pattern['eng-kor-num-space'], 'g').test(value);
    if (value === '' || validate) {
      this.setFileTitle(index, kOrF, value.slice(0, 30));
      this.setFormErrorMessage(index, kOrF, false);
      (e.target as HTMLInputElement).value = value.slice(0, 30);
      return;
    }
    this.setFormErrorMessage(index, kOrF, true);
    (e.target as HTMLInputElement).value =
      kOrF === 'K' ? this.koreaConFileList[index].title : this.foreignConFileList[index].title;
  }
  private setFileTitle(index: number, kOrF: 'K' | 'F', value: string) {
    if (kOrF === 'K') {
      this.koreaConFileList[index].title = value;
      return;
    }
    this.foreignConFileList[index].title = value;
  }
  private setFormErrorMessage(index: number, kOrF: 'K' | 'F', isError: boolean) {
    if (kOrF === 'K') {
      this.koreaConFileList[index].isError = isError;
      return;
    }
    this.foreignConFileList[index].isError = isError;
  }

  private onChangeFile(e, index, kOrF) {
    const [file] = e.target.files;

    if (file && file.size / Math.pow(1024, 2) > 10) {
      alert(this.$t('MALL_FORM_MAX_FILE_SIZE_ALERT'));
      return false;
    } else if (!file) {
      return false;
    }

    const data = new FormData();
    data.append('file', file);
    data.append('mallNo', Number(this.$route.params.id) as any);
    data.append('domestic', (kOrF == 'k' ? true : false) as any);
    data.append('displayOrder', index as any);

    this.$api
      .postStorageContracts({ data })
      .then((res: any) => {
        if (kOrF === 'k') {
          this.koreaConFileList[index].originalFileName = res.data.originalName;
          this.koreaConFileList[index].isDownloadShow = false;
          this.koreaConFileList[index].isXShow = true;
          this.koreaConFileList[index].uploadedFileName = res.data.uploadedName;
        }
        if (kOrF === 'f') {
          this.foreignConFileList[index].originalFileName = res.data.originalName;
          this.foreignConFileList[index].isDownloadShow = false;
          this.foreignConFileList[index].isXShow = true;
          this.foreignConFileList[index].uploadedFileName = res.data.uploadedName;
        }
      })
      .finally((): any => {
        if (kOrF === 'k') {
          $(`input[name=addFileInput_Y_${index}]`).val('');
        }
        if (kOrF === 'f') {
          $(`input[name=addFileInput_N_${index}]`).val('');
        }
      });
  }
  private delFile(index, kOrF) {
    if (kOrF === 'k') {
      $(`input[name=addFileInput_Y_${index}]`).val('');
      this.koreaConFileList[index].originalFileName = '';
      this.koreaConFileList[index].isXShow = false;
      this.koreaConFileList[index].isDownloadShow = true;
      this.koreaConFileList[index].uploadedFileName = '';
      this.koreaConFileList[index].isError = false;
    }
    if (kOrF === 'f') {
      $(`input[name=addFileInput_N_${index}]`).val('');
      this.foreignConFileList[index].originalFileName = '';
      this.foreignConFileList[index].isXShow = false;
      this.foreignConFileList[index].isDownloadShow = true;
      this.foreignConFileList[index].uploadedFileName = '';
      this.foreignConFileList[index].isError = false;
    }
  }
  private downloadFile(index, kOrF) {
    let fileName = '',
      saveAs = '';
    if (kOrF === 'k') {
      fileName = this.koreaConFileList[index].uploadedFileName;
      saveAs = this.koreaConFileList[index].originalFileName;
    }
    if (kOrF === 'f') {
      fileName = this.foreignConFileList[index].uploadedFileName;
      saveAs = this.foreignConFileList[index].originalFileName;
    }
    const params = { params: { fileName, saveAs } };
    this.$api.getStorageContracts(params).then((ret: any) => {
      const myBlob = new Blob([ret.data], { type: 'blob' });
      const qrUrl = window.URL.createObjectURL(myBlob);
      const a = document.createElement('a');
      const event = new MouseEvent('click');
      a.download = saveAs;
      a.href = qrUrl;
      a.dispatchEvent(event);
      window.URL.revokeObjectURL(qrUrl);
    });
  }
  private addFile(kOrF: 'k' | 'f') {
    const obj = {
      title: this.$t('MALL_FORM_CONTRACT_FILES_LABEL').toString(),
      originalFileName: '',
      uploadedFileName: '',
      isDownloadShow: true,
      isXShow: false,
      isError: false,
    };
    const fileList = kOrF === 'k' ? this.koreaConFileList : this.foreignConFileList;
    if (kOrF === 'k') {
      if (fileList.length < this.MAX_FILE_COUNT) {
        fileList.push(obj);
      }
      if (fileList.length >= this.MAX_FILE_COUNT) {
        this.isPlusDisabled = true;
      }
      return;
    } else {
      if (fileList.length < this.MAX_FILE_COUNT) {
        fileList.push(obj);
      }
      if (fileList.length >= this.MAX_FILE_COUNT) {
        this.isPlus2Disabled = true;
      }
      return;
    }
  }
  private removeFile(index, kOrF) {
    if (kOrF === 'k') {
      this.isPlusDisabled = false;
      this.koreaConFileList.splice(index, 1);
    }
    if (kOrF === 'f') {
      this.isPlus2Disabled = false;
      this.foreignConFileList.splice(index, 1);
    }
  }
  private checkBankAccount(e, index) {
    const val: any = $(e.target).val();
    if (!val) {
      this.tradeBankAccountInfo[index].isErrorShow = false;
      return;
    }
    const reg = /^[0-9]+$/;
    if (!reg.test(val)) {
      this.tradeBankAccountInfo[index].isErrorShow = true;
      this.tradeBankAccountInfo[index].bankAccount = val.replace(/\D/g, '');
      setTimeout(() => {
        this.tradeBankAccountInfo[index].isErrorShow = false;
      }, 200);
    }
  }
  private emailUsedChange(e) {
    if ($(e.target).val() === 'false') {
      $('input[name="public-email-appkey"]').prop('readonly', true);
    } else {
      $('input[name="public-email-appkey"]').prop('readonly', false);
    }
  }

  private checkAppkey(e, type) {
    const val: any = $(e.target).val();
    if (!val) {
      type === 'sms' ? (this.isSmsError = false) : (this.isEmailError = false);
      return;
    }
    const reg = /^[0-9a-zA-Z]+$/;
    if (!reg.test(val)) {
      type === 'sms' ? (this.isSmsError = true) : (this.isEmailError = true);
      type === 'sms'
        ? (this.notification.publicSmsAppkey = val.replace(/[^0-9a-zA-Z]/g, ''))
        : (this.notification.publicEmailAppkey = val.replace(/[^0-9a-zA-Z]/g, ''));
      setTimeout(() => {
        type === 'sms' ? (this.isSmsError = false) : (this.isEmailError = false);
      }, 200);
    }
  }
  private checkServiceAll(val, name, regType) {
    const phoneReg = /^[0-9\-+\(\)]+$/;
    const emailReg = /^[a-z0-9+.\-_]+$/;
    const domainReg = /^[a-z0-9\-+.]+$/;

    if (name === 'isEmailErrShow') {
      if (regType === 'mail' && !emailReg.test(val)) {
        this[name] = true;
        this.mall.emailId = this.mall.emailId.replace(/[^a-z0-9+.\-_]/g, '');
        setTimeout(() => {
          this[name] = false;
        }, 200);
      } else if (regType === 'domain' && !domainReg.test(val)) {
        this[name] = true;
        this.mall.emailDomain = this.mall.emailDomain.replace(/[^a-z0-9\-+.]/g, '');
        setTimeout(() => {
          this[name] = false;
        }, 200);
      }
    }
    if (name === 'isOutEmailErrShow') {
      if (regType === 'mail' && !emailReg.test(val)) {
        this[name] = true;
        this.mall.outboundEmailId = this.mall.outboundEmailId.replace(/[^a-z0-9+.\-_]/g, '');
        setTimeout(() => {
          this[name] = false;
        }, 200);
      } else if (regType === 'domain' && !domainReg.test(val)) {
        this[name] = true;
        this.mall.outboundEmailDomain = this.mall.outboundEmailDomain.replace(/[^a-z0-9\-+.]/g, '');
        setTimeout(() => {
          this[name] = false;
        }, 200);
      }
    }
    if (name === 'isPhoneErrShow') {
      if (!phoneReg.test(val)) {
        this[name] = true;
        this.mall.serviceCenterPhoneNo = val.replace(/[^0-9\-+\(\)]/g, '');
        setTimeout(() => {
          this[name] = false;
        }, 200);
      }
    }
  }
  private configUsedChange() {
    const isCon = confirm(this.$t('MALL_FORM_CONFIG_USED_CHANGE_CONFIRM') as string);
    if (isCon) {
      this.isAuthUsedDisabled = true;
      this.isAnotherDisabled1 = true;
    } else {
      $('#mallJoinConfigUsed2').prop('checked', false);
      $('#mallJoinConfigUsed1').prop('checked', true);
    }
  }
  private snsCheck(val, name, obj1, obj2) {
    this[name] = !val;
    if (!val) {
      this[obj1][obj2].clientId = '';
      this[obj1][obj2].secretKey = '';
    }
  }
  private checkWms(e, dataName) {
    const val: any = $(e.target).val();
    const reg = /^[1-9]+$/;
    if (!val) {
      this.isWmsErrShow = false;
      this.isWmsAlertShow = false;
      this.isWmsFailShow = false;
      return;
    }
    if (!reg.test(val)) {
      this.isWmsErrShow = true;
      this.productConfig[dataName] = val.replace(/[^1-9]+$/g, '');
      setTimeout(() => {
        this.isWmsErrShow = false;
      }, 500);
    }
    if (this.productConfig.safetyStockControlPoint) {
      if (Number(this.productConfig.safetyStockCount) > Number(this.productConfig.safetyStockControlPoint)) {
        if (dataName == 'safetyStockControlPoint') {
          this.isWmsFailShow = true;
          this.isWmsAlertShow = false;
        }
        if (dataName == 'safetyStockCount') {
          this.isWmsAlertShow = true;
          this.isWmsFailShow = false;
        }
      } else {
        this.isWmsFailShow = false;
        this.isWmsAlertShow = false;
      }
    }
  }
  private bankEdit(index) {
    this.tradeBankAccountInfo[index].bank = '';
    this.tradeBankAccountInfo[index].bankAccount = '';
    this.tradeBankAccountInfo[index].bankDepositorName = '';
    this.tradeBankAccountInfo[index].isDisabled = false;
  }
  private updateNotification(name, disable, used) {
    if (this.notification[used]) {
      this[disable] = false;
    }
    if (name !== 'smsSendNo') {
      this.notification[name] = '';
    }
  }
  private async beforeSaveCheck() {
    if (!this.mall.mallName) {
      alert(this.$t('MALL_FORM_NO_MALLNAME_ALERT'));
      return false;
    }
    if (!this.configurationI18n.languages.length) {
      alert(this.$t('MALL_FORM_NO_LANGUAGE_ALERT'));
      return false;
    }
    if (!this.validatePurchaseLimitByCountry()) {
      return;
    }

    if (this.mall.timeZone == 'NONE') {
      alert(this.$t('MALL_FORM_NO_TIMEZONE_ALERT'));
      return false;
    }
    if (
      !this.tradeBankAccountInfo[0].bank ||
      !this.tradeBankAccountInfo[0].bankAccount ||
      !this.tradeBankAccountInfo[0].bankDepositorName
    ) {
      alert(this.$t('MALL_FORM_NO_FIRST_ACCOUNT_ALERT'));
      return false;
    }
    for (const tb of this.tradeBankAccountInfo) {
      if (tb.bank) {
        if (tb.bankAccount.length === 0 || tb.bankDepositorName.length === 0) {
          alert(this.$t('MALL_FORM_NO_ACCOUNT_BANKACCOUNT_ALERT'));
          return false;
        }
      } else if (tb.bankAccount.length > 0 || tb.bankDepositorName.length > 0) {
        alert(this.$t('MALL_FORM_NO_ACCOUNT_BANK_ALERT'));
        return false;
      }
    }

    this.mall.serviceCenter.email = this.mall.emailId + '@' + this.mall.emailDomain;
    this.mall.serviceCenter.outboundEmail = this.mall.outboundEmailId + '@' + this.mall.outboundEmailDomain;
    this.mall.serviceCenter.phoneNo = this.mall.serviceCenterPhoneNo;
    if (!this.mall.serviceCenter.phoneNo) {
      alert(this.$t('MALL_FORM_NO_SCPHONE_ALERT'));
      return false;
    }
    const emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (this.mall.serviceCenter.email.trim() == '@' || !emailReg.test(this.mall.serviceCenter.email)) {
      alert(this.$t('MALL_FORM_NO_SCEMAIL_ALERT'));
      return false;
    }
    if (this.mall.serviceCenter.outboundEmail.trim() == '@' || !emailReg.test(this.mall.serviceCenter.outboundEmail)) {
      alert(this.$t('MALL_FORM_NO_OBEMAIL_ALERT'));
      return false;
    }
    if (!this.productConfig.productDetailUrl) {
      alert(this.$t('MALL_FORM_NO_PRODUCT_URL_ALERT'));
      return false;
    }
    if (this.productConfig.productDetailUrl.indexOf('{productNo}') < 0) {
      alert(this.$t('MALL_FORM_NO_CORRECT_PRODUCT_URL_ALERT'));
      return false;
    }
    if (
      this.productConfig.productDetailUrlForMobile &&
      this.productConfig.productDetailUrlForMobile.indexOf('{productNo}') < 0
    ) {
      alert(this.$t('MALL_FORM_NO_CORRECT_PRODUCT_MOBILE_URL_ALERT'));
      return false;
    }
    //  쇼핑몰회원 / 오픈 아이디 회원 중 인증 사용여부 중 1개를 필수로 사용 => 정책 제거
    // if (
    //   !this.mallJoinConfig.used &&
    //   !this.joinConfig.payco.checked &&
    //   !this.joinConfig.naver.checked &&
    //   !this.joinConfig.kakao.checked &&
    //   !this.joinConfig.facebook.checked &&
    //   !this.joinConfig.line.checked
    // ) {
    //   alert(this.$t('MALL_FORM_NO_JOIN_ALERT'));
    //   return false;
    // }
    for (const joinObj in this.joinConfig) {
      if (this.joinConfig[joinObj].checked) {
        if (joinObj === 'kakao') {
          return true;
        }
        if (!this.joinConfig[joinObj].clientId || !this.joinConfig[joinObj].secretKey) {
          alert(this.$t('MALL_FORM_NO_JOIN_CONTENT_ALERT'));
          return false;
        }
      }
    }
    if (this.productConfig.wmsUsed) {
      if (
        !this.productConfig.safetyStockControlPoint ||
        !this.productConfig.safetyStockRatio ||
        !this.productConfig.safetyStockCount ||
        parseInt(this.productConfig.safetyStockControlPoint) < parseInt(this.productConfig.safetyStockCount)
      ) {
        alert(this.$t('MALL_FORM_NO_WMSUSED_CONFIG_ALERT'));
        return false;
      }
    }

    if (this.shippingConfig.inputUrl && this.shippingConfig.inputUrl.indexOf('${encryptedShippingNo}') < 0) {
      alert(this.$t('MALL_FORM_NO_SHIPPINGCONFIG_URL_ALERT'));
      return false;
    }

    if (this.openIdJoinConfig.privacyCollectionUsed && !this.openIdJoinConfig.privacyCollectionSource) {
      alert('수집출처를 입력해주세요.');
      return false;
    }

    // 정기배송 설정 임시 숨김 처리
    // if (this.isRecurringPaymentUsed && Object.values(this.recurringPaymentConfig).some(info => info === '')){
    //   alert(this.$t('MALL_FORM_RECURRING_PAYMENT_CONFIG_NO_INPUT_ALERT_MSG'));
    //   return false;
    // }

    if (!this.checkValidateFilesTitle([...this.koreaConFileList, ...this.foreignConFileList])) {
      alert(this.$t('MALL_FORM_NO_CONTRACT_TITLE_ALERT'));
      return false;
    }

    if (!(await this.paymentSettingRef.validatePaymentSetting())) {
      return false;
    }

    return true;
  }

  private checkValidateFilesTitle(files: ContractFile[]) {
    for (let i = 0; i < files.length; i++) {
      if (!files[i].title && !files[i].originalFileName) continue;
      if (!files[i].title || !files[i].title.trim() || !files[i].uploadedFileName) return false;
      if (!this.checkValidateTitle(files[i].title)) return false;
    }
    return true;
  }
  private checkValidateTitle(title: string) {
    const validate = new RegExp(pattern['eng-kor-num-space'], 'g');
    if (title.length < 1 || title.length > 30 || !validate.test(title)) return false;
    return true;
  }

  private cancel() {
    if (!confirm(this.$t('MALL_FORM_CANCEL_CONFIRM') as string)) {
      return false;
    }
    this.$router.push('/mall/list');
  }
  // ---------------------------------------modification-----------------------------------------------------

  private get exclusiveCurrencyUnit() {
    return this.isInitialSubMallSetup ? this.selectedCurrency : (this.configurationI18n.currencies?.[0]?.exchangeTo ?? 'KRW');
  }

  private get currencyTypeLabel() {
    return `${this.exclusiveCurrencyUnit} (${this.currencyExchange[this.exclusiveCurrencyUnit].specialChar ?? '₩'})`;
  }

  private validateOnBlur(value?: string): boolean {
    if (this.exclusiveCurrencyUnit === 'KRW' && Number(value ?? 0) % 10) {
      alert('10원 단위로 입력해주세요.');

      return false;
    }
    return true;
  }

  private get languageLabel() {
    switch(this.exclusiveCurrencyUnit) {
      case 'USD':
        return '영어';
      case 'JPY':
        return '일본어';
      default:
        return '한국어';
    }
  }

  private getConfigurationI18n() {
    this.$api.getMallsMallNoConfigurationI18n({ pathParams: { mallNo: this.mallNo } }).then(({ data }) => {
      this.configurationI18n = data;

      // 분리형 글로벌몰 기준
      if (!data.currencies?.length) {
        this.isInitialSubMallSetup = true;
        return;
      }

      // 통합몰 / 분리형 글로벌 ( 메인 ) 기준
      this.configurationI18n.currencies.forEach(currency => {
        this.currencyExchange[currency.exchangeTo].value = currency.exchangeRate;
      });
    });
  }

  private getCountries() {
    this.$api.getShippingsEnums().then(({ data: { countryCd } }) => {
      this.countries = countryCd;
    });
  }

  private get mallType() {
    switch (this.mall.globalMallType) {
      case 'INTEGRATED_GLOBAL':
        return '통합형 글로벌';
      case 'SEPARATED_GLOBAL_MAIN':
        return '분리형 글로벌 (메인)';
      case 'SEPARATED_GLOBAL_SUB':
        return '분리형 글로벌 (서브)';
      default:
        return '기본';
    }
  }

  private getFormData() {
    // api request
    const commonRequest: GetMallsDataRequest = {
      params: {
        mallNo: Number(this.mallNo),
      },
      customAxiosOption: {
        on403: this.admin.plan === 'STANDARD' ? () => null : undefined,
      },
    };

    // mall  api request
    this.$api.getMallsData(commonRequest).then(res => {
      if (res.data) {
        const result = { ...res.data };
        for (var i = 0; i < result.tradeBanks.length; i++) {
          this.tradeBankAccountInfo.splice(i, 1);
        }
        this.tradeBankAccountInfo = [...result.tradeBanks, ...this.tradeBankAccountInfo];
        this.tradeBankAccountInfo.forEach(v => {
          if (v.bank) {
            v.isDisabled = true;
          }
        });
        if (result.serviceCenter.email == result.serviceCenter.outboundEmail) {
          this.emailCopy = true;
        }
        this.mall = result;
        this.mall.serviceCenterPhoneNo = result.serviceCenter.phoneNo;
        this.mall.emailId = result.serviceCenter.email.slice(0, result.serviceCenter.email.indexOf('@'));
        this.mall.emailDomain = result.serviceCenter.email.slice(
          result.serviceCenter.email.indexOf('@') + 1,
          result.serviceCenter.email.length,
        );
        this.mall.outboundEmailId = result.serviceCenter.outboundEmail.slice(
          0,
          result.serviceCenter.outboundEmail.indexOf('@'),
        );
        this.mall.outboundEmailDomain = result.serviceCenter.outboundEmail.slice(
          result.serviceCenter.outboundEmail.indexOf('@') + 1,
          result.serviceCenter.outboundEmail.length,
        );
        this.clientId = result.clientId;
        this.externalApiKey = result.externalApiKey;
      }
    });

    this.getConfigurationI18n();
    this.getCountries();

    // notifications api request get成功
    this.$api.getNotificationsConfigurations(commonRequest).then(res => {
      if (res.data) {
        this.notification.emailUsed = res.data.emailUsed;
        this.notification.smsUsed = res.data.smsUsed;
        this.notification.smsSendNo = res.data.smsSendno;
        this.notification.publicSmsAppkey = res.data.publicSmsAppkey;
        this.notification.publicEmailAppkey = res.data.publicEmailAppkey;
        if (this.notification.publicEmailAppkey) {
          this.isEmailAppkeyDisabled = true;
          this.isEmailBtnShow = true;
        }
        if (!this.notification.smsSendNo) {
          this.notification.smsSendNo = '';
        }
      }
    });

    // mallJoinConfig api request get成功
    this.$api.getMemberJoinConfig(commonRequest).then((res: any) => {
      if (res.data) {
        const result = { ...res.data };
        if (result.authenticationTimeType === 'NONE' || result.memberAuthenticationType === 'NOT_USED') {
          result.authenticationUsed = false;
          result.authenticationTimeType = 'JOIN_TIME';
          result.memberAuthenticationType = 'AUTHENTICATION_BY_PHONE';
        } else {
          result.authenticationUsed = true;
        }
        if (!result.used) {
          result.authenticationUsed = false;
          result.authenticationTimeType = 'JOIN_TIME';
          result.memberAuthenticationType = 'AUTHENTICATION_BY_PHONE';
        }
        this.mallJoinConfig = result;
      }
    });

    // openIdJoinConfig api request get成功
    this.$api.getMembersOpenidconfig(commonRequest).then(res => {
      if (res.data) {
        this.openIdJoinConfig = res.data;
        if (res.data.authenticationTimeType === 'NONE') {
          this.openIdJoinConfig.authenticationTimeType = 'JOIN_TIME';
        }
        if (res.data.memberAuthenticationType === 'NOT_USED') {
          this.openIdJoinConfig.memberAuthenticationType = 'AUTHENTICATION_BY_PHONE';
        }
        for (const openIdKey in this.openIdJoinConfig.clientId) {
          if (!this.joinConfig[openIdKey.toLocaleLowerCase()]) {
            continue;
          }
          if (this.openIdJoinConfig.clientId[openIdKey] === '') {
            continue;
          }
          if (openIdKey !== 'KAKAO' && this.openIdJoinConfig.secretKey[openIdKey] === '') {
            continue;
          }
          this.joinConfig[openIdKey.toLowerCase()].checked = true;
          this.joinConfig[openIdKey.toLowerCase()].readonly = true;
          this.joinConfig[openIdKey.toLowerCase()].clientId = this.openIdJoinConfig.clientId[openIdKey];
          this.joinConfig[openIdKey.toLowerCase()].secretKey = this.openIdJoinConfig.secretKey[openIdKey];
        }
      }
    });

    // cartConfig api request get成功
    const orderConfig: GetOrderconfigsCartRequest = {
      params: {
        mallNos: this.mallNo,
      },
    };
    this.$api.getOrderconfigsCart(orderConfig).then(res => {
      if (res.data && res.data[0]) {
        this.cartConfig = res.data[0].value;
        if (this.cartConfig.storagePeriod == 0) {
          this.cartConfig.storagePeriod = 1;
        }
        this.isCartConfigUnitTypeDisabled = true;
      }
    });
    this.$api
      .getOrderConfigsOrder({
        params: {
          mallNos: this.mallNo.toString(),
        },
      })
      .then((res: NCPResponse<GetOrderConfigsOrder[]>) => {
        if (res.data && res.data[0]) {
          const convertData = Object.fromEntries(
            Object.entries(res.data[0].value).filter(
              ([key]) => !['useRecurringPayment', 'recurringPaymentKeys'].includes(key),
            ),
          );
          this.orderConfig = convertData;
        }
      });
    this.$api
      .getClaimsConfigs({
        params: {
          mallNos: this.mallNo.toString(),
        },
      })
      .then(({ data }) => data[0].value)
      .then((config) => {
        this.claimConfig = config;
      });
    // ProductsConfiguration api request get成功
    this.$api.getProductsConfiguration(commonRequest).then(res => {
      if (res.data) {
        this.productConfig = res.data;
        this.isProductWmsDisabled = true;
        this.productConfig.wmsCompany = 'CJINEX';
      }
    });

    // orderConfig api request get成功
    this.$api.getOrderConfigsOrder(orderConfig).then(res => {
      if (res.data && res.data[0]) {
        const responseValue = res.data[0].value;
        this.orderConfig = responseValue;

        if (this.orderConfig.purchaseLimitByCountry && Object.entries(this.orderConfig.purchaseLimitByCountry).length) {
          this.maximumOrderAmounts = Object.entries(this.orderConfig.purchaseLimitByCountry).map(([name, value]) => ({
            key: this.makeUniqueId(),
            name,
            value: Number(value),
          }));
        }

        // 정기결제 설정 임시 숨김처리

        // this.isRecurringPaymentUsed = responseValue.useRecurringPayment;
        //
        // // KCP 정기결제만 기획되어 있으므로, 해당 경우만 핸들 중
        // // 데이터 구조상 etcInfos는 추후에 다양한 형식으로 들어올 것으로 보임
        // const { pgType, key, etcInfos } = responseValue.recurringPaymentKeys[0];
        // this.recurringPaymentConfig = {
        //   pgType: pgType,
        //   siteKey: key,
        //   siteCode: etcInfos.siteCd,
        //   groupId: etcInfos.kcpGroupId,
        // }
      }
    });

    // Settlementsconfigu api request
    const settlementsConfig: GetSettlementsconfigurationsRequest = {
      params: {
        mallNo: this.mallNo,
      },
    };
    this.$api.getSettlementsConfigurationsV2(settlementsConfig).then(res => {
      if (res.data) {
        this.settlementsConfig.settlementTargetStatus = res.data.settlementTargetStatus;
      }
    });

    // Contractfiles api request get成功
    this.$api.getContractfilesMalls(commonRequest).then(res => {
      if (res.data) {
        const koreaConFileList = res.data.domesticFiles.length
          ? [...res.data.domesticFiles]
          : [...this.koreaConFileList];
        res.data.domesticFiles.length &&
          koreaConFileList.forEach(v => {
            v.isXShow = true;
            v.isDownloadShow = false;
            v.originalFileName = v.originalName;
            v.uploadedFileName = v.uploadedName;
            v.title = v.title || this.$t('MALL_FORM_CONTRACT_FILES_LABEL');
            v.isError = v.false;
          });
        this.koreaConFileList = koreaConFileList;
        this.koreaFileGuide = res.data.domesticGuide;
        this.isPlusDisabled = res.data.domesticFiles.length >= this.MAX_FILE_COUNT;

        if (res.data.globalFiles) {
        const foreignConFileList = res.data.globalFiles.length
          ? [...res.data.globalFiles]
          : [...this.foreignConFileList];
        res.data.globalFiles.length &&
          foreignConFileList.forEach(v => {
            v.isXShow = true;
            v.isDownloadShow = false;
            v.originalFileName = v.originalName;
            v.uploadedFileName = v.uploadedName;
            v.title = v.title || this.$t('MALL_FORM_CONTRACT_FILES_LABEL');
            v.isError = v.false;
          });
        this.foreignConFileList = foreignConFileList;
        this.foreignFileGuide = res.data.globalGuide;
        this.isPlus2Disabled = res.data.globalFiles.length >= this.MAX_FILE_COUNT;
        }
      }
    });

    // accumulationConfig api request get成功
    this.$api.getAccumulationsConfigurations(commonRequest).then(res => {
      if (res.data && res.data.length) {
        const result = res.data[0];
        this.accumulationConfig.productAccumulationUsable = result.basic.productAccumulationUsable;
        this.accumulationConfig.memberAccumulationUsable = result.basic.memberAccumulationUsable;
      }
    });

    // shippingconfig api request get成功
    this.$api.getOrderConfigsShipping(orderConfig).then(res => {
      if (res.data && res.data[0]) {
        const { inputUrl, shippingEmptyAutoCancel, shippingInputNotification, recurringPaymentInputUrl } = res.data[0].value;

        this.shippingConfig = {
          inputUrl: inputUrl ?? DEFAULT_SHIPPING_CONFIG.inputUrl,
          shippingEmptyAutoCancel: shippingEmptyAutoCancel ?? DEFAULT_SHIPPING_CONFIG.shippingEmptyAutoCancel,
          shippingInputNotification: shippingInputNotification ?? DEFAULT_SHIPPING_CONFIG.shippingInputNotification,
          recurringPaymentInputUrl: recurringPaymentInputUrl ?? DEFAULT_SHIPPING_CONFIG.recurringPaymentInputUrl,
        };
      }
    });
  }
  private toAppToken() {
    window.open(`/app/token?mallNo=${this.mallNo}`, '_blank');
  }
  private getContract() {
    const getRequest: GetContractsEntryConfigurationsRequest = {
      params: {
        mallNo: Number(this.mallNo),
      },
    };
    this.$api.getContractsEntryConfigurations(getRequest).then(ret => {
      if (ret.data && ret.data.entryContractContentsOfMall) {
        sessionStorage.setItem('contractContent', ret.data.entryContractContentsOfMall);
        this.isHaveContract = true;
        this.contractContent = ret.data.entryContractContentsOfMall;
      }
    });
  }
  private showRegisterPop() {
    (window as any).updateMallStandardContractStatus = this.updateMallStandardContractStatus;
    const url = `/contract/standingPointContract/popup?type=standard&mallNo=${this.mallNo}&updateYn=false&callback=updateMallStandardContractStatus`;
    ncpPopup(url, this.$t('MALL_FORM_STANDING_POPUP_TITLE') as string, 1000, 700);
  }
  private showUpdatePop() {
    sessionStorage.setItem('contractContent', this.contractContent);
    (window as any).updateMallStandardContractStatus = this.updateMallStandardContractStatus;
    const url = `/contract/standingPointContract/popup?type=standard&mallNo=${this.mallNo}&updateYn=true&callback=updateMallStandardContractStatus`;
    ncpPopup(url, this.$t('MALL_FORM_STANDING_POPUP_TITLE') as string, 1000, 700);
  }
  private updateMallStandardContractStatus(content) {
    this.isHaveContract = true;
    this.contractContent = content;
    sessionStorage.removeItem('contractContent');
  }
  private delContract() {
    if (!confirm(this.$t('MALL_FORM_DELETE_CONTRACT_CONFIRM') as string)) {
      return;
    }
    this.isHaveContract = false;
    this.contractContent = '';
  }

  private sendNoCheck(e) {
    const val: any = $(e.target).val();
    if (!val) {
      this.isSendNoError = false;
      return;
    }
    const reg = /^[0-9]+$/;
    if (!reg.test(val)) {
      this.isSendNoError = true;
      this.newSendNo.phoneNo = val.replace(/[^0-9]/g, '');
      setTimeout(() => {
        this.isSendNoError = false;
      }, 200);
    }
  }
  private addSendFile() {
    $('input[name=smsSenderAddFileInput]').click();
  }
  private onSendFileChange(e) {
    if (!this.newSendNo.phoneNo || this.newSendNo.phoneNo === '') {
      (this.$refs.smsSenderFile as any).value = null;
      alert(this.$t('MALL_FORM_SENDNO_POPUP_PLACEHOLDER'));
      return;
    }
    const [file] = e.target.files;
    const data = new FormData();
    data.append('file', file);

    this.$api
      .postStorage({ data })
      .then((res: any) => {
        this.newSendNo.originalFileName = file.name;
        this.newSendNo.uploadedFileName = res.data.uploadedFileName;
        (this.$refs.smsSenderFile as any).value = null;
      })
      .finally((): any => {
        (this.$refs.smsSenderFile as any).value = null;
      });
  }
  private downloadSendFile() {
    const params = { fileName: this.newSendNo.uploadedFileName, container: 'ncp' };
    this.$api.getStorage({ params, responseType: 'blob' }).then((ret: any) => {
      const myBlob = new Blob([ret.data], { type: 'application/octet-stream' });
      const qrUrl = window.URL.createObjectURL(myBlob);
      const a = document.createElement('a');
      const event = new MouseEvent('click');
      a.download = this.newSendNo.originalFileName;
      a.href = qrUrl;
      a.dispatchEvent(event);
      window.URL.revokeObjectURL(qrUrl);
    });
  }

  private showAuthTypeConfirm(value, id) {
    const toCheck = $(`#${id}_authType input[value=${value}]`);
    const curCheck = $(`#${id}_authType input[value=${this[id].memberAuthenticationType}]`);
    const curValue = this[id].memberAuthenticationType;

    if (this.mallNo) {
      let isConfirm: boolean = undefined;

      if (id === 'mallJoinConfig') {
        if (curValue === 'AUTHENTICATION_BY_PHONE') {
          isConfirm = confirm(this.$t('MALL_FORM_MALLJOIN_CONFIG_AUTHENTICATION_BY_PHONE_CONFIRM') as string);
        } else if (curValue === 'SMS_OCCUPANCY_AUTHENTICATION') {
          isConfirm = confirm(this.$t('MALL_FORM_MALLJOIN_CONFIG_SMS_OCCUPANCY_AUTHENTICATION_CONFIRM') as string);
        } else if (curValue === 'AUTHENTICATION_BY_EMAIL') {
          isConfirm = confirm(this.$t('MALL_FORM_MALLJOIN_CONFIG_AUTHENTICATION_BY_EMAIL_CONFIRM') as string);
        }
      } else if (id === 'openIdJoinConfig') {
        if (curValue === 'AUTHENTICATION_BY_PHONE') {
          isConfirm = confirm(this.$t('MALL_FORM_OPENIDJOIN_CONFIG_AUTHENTICATION_BY_PHONE_CONFIRM') as string);
        } else if (curValue === 'SMS_OCCUPANCY_AUTHENTICATION') {
          isConfirm = confirm(this.$t('MALL_FORM_OPENIDJOIN_CONFIG_SMS_OCCUPANCY_AUTHENTICATION_CONFIRM') as string);
        } else if (curValue === 'AUTHENTICATION_BY_EMAIL') {
          isConfirm = confirm(this.$t('MALL_FORM_OPENIDJOIN_CONFIG_AUTHENTICATION_BY_EMAIL_CONFIRM') as string);
        }
      }

      if (!isConfirm) {
        curCheck.prop('checked', true);
        toCheck.prop('checked', false);
        return;
      }
      this[id].memberAuthenticationType = value;
    }
  }

  //결제수단 노출설정 수정
  private async putPayTypes() {
    const request: PutOrderConfigsPaymentsPayTypesRequest = {
      data: { enablePays: this.pgPayTypes, mallNo: Number(this.mallNo) },
    };
    return await this.$api.putOrderConfigsPaymentsPayTypes(request);
  }

  private async modifySave() {
    if (!(await this.beforeSaveCheck())) {
      return;
    }

    if (!confirm(window.$t('MALL_FORM_EDIT_SAVE_ALERT'))) {
      return;
    }
    // mall api 成功
    this.mall.serviceCenter.email = this.mall.emailId + '@' + this.mall.emailDomain;
    this.mall.serviceCenter.outboundEmail = this.mall.outboundEmailId + '@' + this.mall.outboundEmailDomain;
    this.mall.serviceCenter.phoneNo = this.mall.serviceCenterPhoneNo;
    this.mall.tradeBanks = this.tradeBankAccountInfo;
    const mallObj = JSON.parse(JSON.stringify(this.mall));
    mallObj.tradeBanks = mallObj.tradeBanks.filter(v => {
      if (v.bank) {
        return v;
      }
    });
    mallObj.tradeBanks.forEach(v => {
      delete v.isErrorShow;
      delete v.isDisabled;
    });
    delete mallObj.serviceCenterPhoneNo;
    delete mallObj.emailDomain;
    delete mallObj.emailId;
    delete mallObj.outboundEmailId;
    delete mallObj.outboundEmailDomain;
    const mall: PutMallsRequest = {
      params: {
        mallNo: this.mallNo,
      },
      data: mallObj,
    };
    const mallModifyPromise = () =>
      new Promise<void>((resolve, reject) => {
        this.$api
          .putMalls(mall)
          .then(() => {
            resolve();
          })
          .catch(err => reject(err));
      });

    const configurationI18nPromise = () => {
      return new Promise<void>((resolve, reject) => {
        const configurationI18n = {
          ...this.configurationI18n,
          currencies: [
            ...Object.entries(this.currencyExchange)
              .map(([key, data]) => ({ exchangeTo: key, exchangeRate: Number(data.value) }))
              .filter(({ exchangeRate }) => !!exchangeRate),
          ],
        };
        this.$api
          .putMallsMallNoConfigurationI18n({ pathParams: { mallNo: this.mallNo }, data: configurationI18n })
          .then(() => resolve())
          .catch(err => reject(err));
      });
    };



    const putCurrencyRate = () => {
      return new Promise<void>((resolve, reject) => {
        const request = {
          pathParams: {
            mallNo: this.mallNo,
          },
          data: {
            currencyRate: Number(
              this.currencyExchange[this.configurationI18n.currencies?.[0]?.exchangeTo ?? this.selectedCurrency]
                .value ?? 0,
            ),
          },
        };
        this.$api
          .putMallsMallNoConfigurationI18nCurrencyRate(request)
          .then(() => resolve())
          .catch(err => reject(err));
      });
    };

    const postCurrencySetting = () => {
      return new Promise<void>((resolve, reject) => {
        const request = {
          pathParams: {
            mallNo: this.mallNo,
          },
          data: {
            currency: this.selectedCurrency as CurrencyCode,
          },
        };
        this.$api
          .postMallsMallNoConfigurationI18nCurrency(request)
          .then(async () => {
            await putCurrencyRate();
            resolve()
          })
          .catch(err => reject(err));
      });
    };

    // 결제수단 및 노출여부
    const orderConfigsPaymentsPayTypesPromise = () => new Promise<void>((resolve, reject) => {
      this.putPayTypes().then(()=>{
        resolve();
      }).catch((err) => reject(err));
    })

    // notification api
    const notification: PatchNotificationsConfigurationsRequest = {
      params: {
        mallNo: Number(this.mallNo),
      },
      data: this.notification,
    };
    const notificationModifyPromise = () =>
      new Promise<void>((resolve, reject) => {
        this.$api
          .patchNotificationsConfigurations(notification)
          .then(() => {
            resolve();
          })
          .catch(err => reject(err));
      });

    // mallJoinConfig api
    const joinConfigObj = {
      used: true,
      memberAuthenticationType: '',
      authenticationTimeType: '',
      dormantStatusUsed: true,
      pendingStatusUsed: false,
    };
    joinConfigObj.used = this.mallJoinConfig.used;
    joinConfigObj.memberAuthenticationType = this.mallJoinConfig.memberAuthenticationType;
    joinConfigObj.authenticationTimeType = this.mallJoinConfig.authenticationTimeType;
    if (!joinConfigObj.used || !this.mallJoinConfig.authenticationUsed) {
      joinConfigObj.authenticationTimeType = 'NONE';
      joinConfigObj.memberAuthenticationType = 'NOT_USED';
    }
    joinConfigObj.dormantStatusUsed = this.mallJoinConfig.dormantStatusUsed;
    joinConfigObj.pendingStatusUsed = this.mallJoinConfig.pendingStatusUsed;

    const mallJoinConfig = {
      params: {
        mallNo: Number(this.mallNo),
      },
      data: joinConfigObj,
    };
    const mallJoinConfigModifyPromise = () =>
      new Promise<void>((resolve, reject) => {
        this.$api
          .patchMembersJoinconfig(mallJoinConfig)
          .then(() => {
            resolve();
          })
          .catch(err => reject(err));
      });

    // openIdJoinConfig api
    for (const joinObj in this.joinConfig) {
      if (this.joinConfig[joinObj].checked) {
        this.openIdJoinConfig.clientId[joinObj.toUpperCase()] = this.joinConfig[joinObj].clientId;
        this.openIdJoinConfig.secretKey[joinObj.toUpperCase()] = this.joinConfig[joinObj].secretKey;
      }
    }
    const openIdJoinConfig: PostMembersOpenidconfigRequest = {
      params: {
        mallNo: Number(this.mallNo),
      },
      data: this.openIdJoinConfig,
    };
    const openIdJoinConfigModifyPromise = () =>
      new Promise<void>((resolve, reject) => {
        this.$api
          .patchMembersOpenidconfig(openIdJoinConfig)
          .then(() => {
            resolve();
          })
          .catch(err => reject(err));
      });

    // cartConfig api 成功
    const cartConfig: PutOrderconfigsCartRequest = {
      params: {
        mallNo: Number(this.mallNo),
      },
      data: this.cartConfig,
    };
    const cartConfigModifyPromise = () =>
      new Promise<void>((resolve, reject) => {
        this.$api
          .putOrderconfigsCart(cartConfig)
          .then(() => {
            resolve();
          })
          .catch(err => reject(err));
      });

    // productConfig api  成功
    const productConfig: PutProductsConfigurationRequest = {
      data: this.productConfig,
    };
    productConfig.data.mallNo = Number(this.mallNo);
    const productConfigModifyPromise = () =>
      new Promise<void>((resolve, reject) => {
        this.$api
          .putProductsConfiguration(productConfig)
          .then(() => {
            resolve();
          })
          .catch(err => reject(err));
      });

    const productStockConfig: PatchProductsConfigurationRequest = {
      data: {
        mallNo: Number(this.mallNo),
        displayStock: this.productConfig.displayStock,
      },
    };
    const patchProductStockConfigPromise = () =>
      new Promise<void>((resolve, reject) => {
        this.$api
          .patchProductsConfiguration(productStockConfig)
          .then(() => {
            resolve();
          })
          .catch(err => reject(err));
      });

    // orderConfig api 成功

    // 현재 this.orderConfig 관리가 다소 미흡한 상태
    // 이에 따라, 아래 thisOrderConfig 생성과 같은 작은 하드코딩 진행
    const thisOrderConfig = _.omit(this.orderConfig, 'useRecurringPayment', 'recurringPaymentKeys');

    const purchaseLimitByCountry = this.maximumOrderAmounts.reduce(
      (prev, item) => (item.name !== '' ? { ...prev, [item.name]: Number(item.value) } : prev),
      {},
    );

    const orderConfig: PutOrderconfigsOrderRequest = {
      params: {
        mallNo: Number(this.mallNo),
      },
      data: {
        ...thisOrderConfig,
        // 정기결제 설정 임시 숨김 처리
        // useRecurringPayment: this.isRecurringPaymentUsed,
        // recurringPaymentConfig: this.recurringPaymentConfig,
        purchaseLimitByCountry,
      },
    };
    const orderConfigModifyPromise = () =>
      new Promise<void>((resolve, reject) => {
        this.$api
          .putOrderconfigsOrder(orderConfig)
          .then(() => {
            resolve();
          })
          .catch(err => reject(err));
      });

    const putClaimsConfigsPromise = () =>
      new Promise<void>((resolve, reject) => {
        this.$api
          .putClaimsConfigs({
            data: {
              mallNo: Number(this.mallNo),
              ...this.claimConfig,
            },
          })
          .then(() => {
            resolve();
          })
          .catch(err => reject(err));
      });

    // settlementsConfig api
    const settlementsConfig: PatchSettlementsConfigurationsRequest = {
      params: {
        mallNo: this.mallNo,
      },
      data: this.settlementsConfig,
    };
    const settlementsConfigModifyPromise = () =>
      new Promise<void>((resolve, reject) => {
        this.$api
          .patchSettlementsConfigurations(settlementsConfig)
          .then(() => {
            resolve();
          })
          .catch(err => reject(err));
      });

    // accumulationConfig api 成功
    const accumulationConfig: PutAccumulationsConfigurationsRequest = {
      data: {
        mallNo: Number(this.mallNo),
        basic: this.accumulationConfig,
        payment: {},
        use: {},
      },
    };
    const accumulationConfigModifyPromise = () =>
      new Promise<void>((resolve, reject) => {
        this.$api
          .putAccumulationsConfigurations(accumulationConfig)
          .then(() => {
            resolve();
          })
          .catch(err => reject(err));
      });

    //  shippingConfig api
    const shippingConfig: PutOrderConfigsShippingRequest = {
      params: {
        mallNo: this.mallNo,
      },
      data: this.shippingConfig,
    };

    const shippingConfigModifyPromise = () =>
      new Promise<void>((resolve, reject) => {
        this.$api
          .putOrderConfigsShipping(shippingConfig)
          .then(() => {
            resolve();
          })
          .catch(err => reject(err));
      });

    //  contract api
    const contractRequest: PutContractsEntryConfigurationsRequest = {
      params: {
        mallNo: Number(this.mallNo),
      },
      data: {
        entryContractContentsOfMall: this.contractContent,
      },
    };
    const contractConfigModifyPromise = () =>
      new Promise<void>((resolve, reject) => {
        this.$api
          .putContractsEntryConfigurations(contractRequest)
          .then(() => {
            resolve();
          })
          .catch(err => reject(err));
      });

    // contractConfig api
    const kConFileList: any[] = [];
    this.koreaConFileList.forEach(item => {
      if (item.title.trim()) {
        kConFileList.push({
          name: item.uploadedFileName,
          title: item.title.trim(),
        });
      }
    });

    const fConFileList: any[] = [];
    this.foreignConFileList.forEach(item => {
      if (item.title.trim()) {
        fConFileList.push({
          name: item.uploadedFileName,
          title: item.title.trim(),
        });
      }
    });

    const contractfilesMallsConfig: PutContractfilesMallsRequest = {
      headers: {
        Version: '1.1',
      },
      data: {
        mallNo: Number(this.mallNo),
        domesticGuide: this.koreaFileGuide,
        globalGuide: this.foreignFileGuide,
        domesticFiles: kConFileList,
        globalFiles: fConFileList,
      },
      customAxiosOption: {
        on403: this.admin.plan === 'STANDARD' ? () => null : undefined,
      },
    };
    const contractfilesMallsConfigPromise = () =>
      new Promise<void>((resolve, reject) => {
        this.$api
          .putContractfilesMalls(contractfilesMallsConfig)
          .then(() => {
            resolve();
          })
          .catch(err => reject(err));
      });

    const patchDeepLinkData = {
      aosUploadedFileName: this.aosUploadedFileName,
      iosUploadedFileName: this.iosUploadedFileName,
    };
    const filteredPatchDeepLinkData = Object.fromEntries(
      Object.entries(patchDeepLinkData).filter(([_, value]) => value !== null),
    );

    const patchDeepLinkPromise = () =>
      new Promise<void>((resolve, reject) => {
        this.$api
          .patchMallsMallNoConfigurationDeepLink({
            params: { mallNo: this.mallNo },
            data: filteredPatchDeepLinkData,
          })
          .then(() => {
            resolve();
          })
          .catch(err => reject(err));
      });

    /**
     * NOTE: /order-configs/order와 /order-configs/payments/pay-types 를 동시에 호출할 경우
     * 400 `다른 작업을 처리중입니다. 잠시 후 다시 시도해 주세요.`로 응답하기 때문에
     * API를 두 그룹으로 나누어 순차적으로 호출함
     */
    const promises1 = [
      orderConfigModifyPromise,
    ];

    await Promise.allSettled(promises1.map(promise => promise()));

    const promises2 = [
      mallModifyPromise,
      notificationModifyPromise,
      mallJoinConfigModifyPromise,
      openIdJoinConfigModifyPromise,
      cartConfigModifyPromise,
      productConfigModifyPromise,
      patchProductStockConfigPromise,
      settlementsConfigModifyPromise,
      accumulationConfigModifyPromise,
      orderConfigsPaymentsPayTypesPromise,
      putClaimsConfigsPromise,
      shippingConfigModifyPromise,
      contractConfigModifyPromise,
      contractfilesMallsConfigPromise,
    ];

    if (filteredPatchDeepLinkData) {
      promises2.push(patchDeepLinkPromise);
    }

    if (this.mall.globalMallType === 'INTEGRATED_GLOBAL') {
      promises2.push(configurationI18nPromise);
    }

    if (this.isInitialSubMallSetup) {
      promises2.push(postCurrencySetting);
    }

    if (['SEPARATED_GLOBAL_SUB'].includes(this.mall.globalMallType) && !this.isInitialSubMallSetup) {
      promises2.push(putCurrencyRate);
    }

    Promise.allSettled(promises2.map(promise => promise())).then(results => {
      Promise.all(
        results.map(async (result, index) => {
          result.status === 'rejected' && (await promises2[index]());
        }),
      ).then(() => {
        alert(this.$t('MALL_FORM_MODIFY_SAVE_SUCESS_ALERT'));
        this.$router.push('/mall/list');
      });
    });
  }

  private checkMallName(e) {
    const val: any = $(e.target).val();
    if (!val) {
      return;
    }
    const reg = /^[a-zA-Z0-9ㄱ-힣-_ ,.]+$/;
    if (!reg.test(val)) {
      this.isMallNameErrorShow = true;
      this.mall.mallName = val.replace(/[^a-zA-Z0-9ㄱ-힣-_ ,.]/g, '');
      setTimeout(() => {
        this.isMallNameErrorShow = false;
      }, 200);
    }
  }

  private handleExcludesAutoBuy() {
    const checkbox = this.$refs.excludesAutoBuy as HTMLInputElement;

    if (!this.orderConfig.excludesAutoBuyConfirmOfServiceProductGroup) {
      this.orderConfig.excludesAutoBuyConfirmOfServiceProductGroup = true;
      checkbox.checked = true;

      return;
    }

    const result = confirm(this.$t('MALL_FORM_EXCLUDE_AUTO_BUY_CONFIRM').toString());

    this.orderConfig.excludesAutoBuyConfirmOfServiceProductGroup = !result;
    checkbox.checked = !result;
  }

  private async fetchDeepLinkInfo() {
    const { data } = await this.$api.getMallsMallNoConfigurationDeepLink({
      params: { mallNo: this.mallNo },
    });

    this.aosFIleUrl = data.aosDeepLinkUrl;
    this.iosFIleUrl = data.iosDeepLinkUrl;
    if (data.aosDeepLinkUrl) {
      this.aosFileName = AOS_FILE_NAME;
    }

    if (data.iosDeepLinkUrl) {
      this.iosFileName = IOS_FILE_NAME;
    }
  }

  private async checkMainDomains(): Promise<boolean> {
    if (this.mall.url.pc.includes(process.env.VUE_APP_SHOPBY_DOMAIN)) {
      return true;
    }

    try {
      const { data } = await axios({
        headers: {
          Version: '1.0',
          'Content-Type': 'application/json',
          accessToken,
        },
        method: 'get',
        url: `${process.env.VUE_APP_COMMERCE_API_URL}/malls/${this.mallNo}/ssl`,
      });

      if (!data.length) {
        return false;
      }

      const mainDomainInfo = data.find(domain => domain.isMain);
      return mainDomainInfo.sslStatus === 'INSTALLED';
    } catch (error) {
      alert(error.message);
    }
  }

  private removeCurrentFile(type: DeepLinkType) {
    if (type === 'aos') {
      this.aosUploadedFileName = '';
      this.aosFileName = '';
      this.aosFIleUrl = '';
    } else {
      this.iosUploadedFileName = '';
      this.iosFileName = '';
      this.iosFIleUrl = '';
    }
  }

  private async postFile(fileData: FormData, type: DeepLinkType) {
    const { data } = await this.$api.postStorage({ data: fileData });

    if (!data) {
      return;
    }

    if (type === 'aos') {
      this.aosUploadedFileName = data.uploadedFileName;
      this.aosFileName = data.originalFileName;
    } else {
      this.iosUploadedFileName = data.uploadedFileName;
      this.iosFileName = data.originalFileName;
    }
  }

  private async addDeepLinkFile(e, type: DeepLinkType) {
    if (!(await this.checkMainDomains())) {
      alert(this.$t('MALL_FORM_DOMAIN_SSL_NOT_INSTALLED'));
      return;
    }

    const [file] = e.target.files;

    if (
      (type === 'ios' && file.name !== IOS_FILE_NAME) ||
      (type === 'aos' && file.name !== AOS_FILE_NAME) ||
      !file.name.toLowerCase().match('json')
    ) {
      alert(this.$t('MALL_FORM_CHECK_FILE_NAME'));
      return;
    }

    const fileData = new FormData();
    fileData.append('file', file);
    fileData.append('container', 'app-deep-link');
    await this.postFile(fileData, type);

    (this.$refs[type === 'aos' ? 'aosFileInputRef' : 'iosFileInputRef'] as HTMLInputElement).value = '';
    type === 'aos' ? (this.aosFIleUrl = '') : (this.iosFIleUrl = '');
  }

  private changeDeleteExpiredOrder(e: Event) {
    const target = e.target as HTMLInputElement;

    if (
      !this.orderConfig.deleteExpiredOrder &&
      target.value === 'true' &&
      !confirm(
        '5년 경과한 거래 기록 데이터를 매일 자동으로 삭제 처리하시겠습니까? 삭제된 데이터는 복원 및 복구가 불가합니다.',
      )
    ) {
      e.preventDefault();
    }

    if (
      !!this.orderConfig.deleteExpiredOrder &&
      target.value === 'false' &&
      !confirm(
        '개인정보보호법에 따라 보유기간 경과 및 처리 목적이 달성된 개인정보는 지체없이 파기해야 합니다. 설정을 변경하는 경우 5년 경과 거래 기록이 자동 삭제 처리되지 않습니다. 설정을 변경하시겠습니까?',
      )
    ) {
      e.preventDefault();
    }
  }
}
